import {useState, useCallback, useRef, useEffect, CSSProperties} from "react";
import './dropdown.css';

interface iProps {
  label: string;
  buttonClass: string;
  children: any;
  isSmallScreen: boolean;
};

export default function Dropdown(props: iProps) {
  const [open, setOpen] = useState(false);
  const dropdownButton = useRef<any>(null);
  const dropdownContent = useRef<any>(null);

  const windowClickListener = useCallback((evt: any) => {
    if (evt.target === dropdownButton.current) {
      return;
    }

    if (dropdownContent.current) {
      if (!dropdownContent.current.contains(evt.target)) {
        setOpen(false);
        window.removeEventListener('click', windowClickListener);
      }
    }
  }, [])

  // cleans up event listener
  useEffect(() => {
    return () => {
      window.removeEventListener('click', windowClickListener);
    }
  }, [windowClickListener]);


  const toggleDropdown = (evt: any) => {
    if (!open) {
      setOpen(true);
      window.addEventListener('click', windowClickListener);
    } else {
      closeDropdown(evt);
    }
  }

  const closeDropdown = (evt: any) => {
    setOpen(false);
    window.removeEventListener('click', windowClickListener);
  }

  let contentStyle: CSSProperties = {}
  let dropdownStyle: CSSProperties = {}
  if (props.isSmallScreen) {
    dropdownStyle = {
      position: 'unset'
    };
    contentStyle = {
      margin: 0,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      border: 'none',
      boxShadow: 'none'
    };
  }

  if (!open) {
    contentStyle.display = 'none'
  }

  return (
    <div style={dropdownStyle} className="dropdown">
      <button className={`dropdown-btn ${props.buttonClass}`}
        onClick={toggleDropdown}
        ref={dropdownButton}>{props.label}</button>
      <div style={contentStyle} className="dropdown-content" ref={dropdownContent}>
        <div className="child-content">
          {props.children}
        </div>
        <div className="close-button-container">
          <button className="close-button bg-orange no-border" onClick={closeDropdown}>Close</button>
        </div>
      </div>
    </div>
  );
}